import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp } from "react-icons/fa";
import logo from "../../assets/img/logo-footer.png";
import { Button } from "react-scroll";

const Footer = () => {
  return (
    <Container>
      <Row>
        <Col md={11} className="mx-auto">
          <footer className="footer-section">
            <Container>
              <Row className="align-items-start">
                {/* Logo + redes */}
                <Col md={6} className="text-md-center text-md-start ps-md-5">
                  <div className="ps-md-5">
                    <img src={logo} alt="MC Brokers" className="footer-logo mb-md-0 mb-4" />

                    <div className="footer-social mt-4 mb-md-0 mb-4">
                      <a
                        href="https://www.linkedin.com/company/mcbrokers/?originalSubdomain=mx"
                        aria-label="LinkedIn"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaLinkedinIn />
                      </a>
                      <a
                        href="https://www.instagram.com/mcbrokersmexico/"
                        aria-label="Instagram"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FaInstagram />
                      </a>

                      <a href="https://x.com/mcbrokersmx" aria-label="Twitter" target="_blank" rel="noreferrer">
                        <FaTwitter />
                      </a>
                    </div>
                  </div>
                </Col>

                {/* Contacto */}
                <Col md={6} className="footer-contact text-start  mt-4 mt-md-0">
                  <div className="footer-contact-box">Contactanos:</div>
                  <p>Email: servicio@mcb.uno</p>
                  <p>
                    Teléfono: <strong>55 5203 0377</strong>
                  </p>
                  <p>
                    Dirección: Miguel de Cervantes Saavedra 169
                    <br />
                    Piso 2 Colonia Granada, Mexico City, Mexico
                  </p>

                  <Button
                    className="contacto-btn mt-4 mb-4"
                    href="https://api.whatsapp.com/send?
phone=5215552030377&text=Hola%2C%20escribo%20desde%20el%20portal%20
web%20de%20MCBrokers.%20%F0%9F%8C%90"
                    target="_blank"
                  >
                    <FaWhatsapp /> Quiero comunicarme
                  </Button>
                </Col>
              </Row>

              {/* Copyright */}
              <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-3">
                <p className="mb-2 mb-md-0">© 2025 MCBrokers. All Rights Reserved.</p>
                <a href="#" className="footer-privacy">
                  Privacy Policy
                </a>
              </div>
            </Container>
          </footer>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;

